export default __webpack_public_path__ + "static/media/logo.944a5e27.svg";